module.exports = __webpack_public_path__ + "static/media/sanu.511ea996.svg";